<script lang="ts">
import CheckSVG from '../Icon/icons/check.svg';

type Props = {
  checked?: boolean;
  disabled?: boolean;
};
</script>
<script setup lang="ts">
const emit = defineEmits(['change']);

defineProps<Props>();
</script>

<template>
  <div :class="[$style.container, checked && $style.checked]">
    <CheckSVG :class="$style.icon" />
    <input
      :checked="checked"
      :class="$style.input"
      :disabled="disabled"
      type="checkbox"
      @click="emit('change', !checked)"
    />
  </div>
</template>

<style module lang="scss">
@forward './Checkbox';
</style>
